export const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('/app/frontend/src/pages/index.vue'),
    /* no children */
    meta: {
      "requiresAuth": false
    }
  },
  {
    path: '/debug',
    name: 'Debug',
    component: () => import('/app/frontend/src/pages/debug.vue'),
    /* no children */
    meta: {
      "requiresAuth": true,
      "requiresAdmin": true
    }
  },
  {
    path: '/dev',
    /* internal name: '/dev' */
    /* no component */
    children: [
      {
        path: 'home',
        name: 'Home preview',
        component: () => import('/app/frontend/src/pages/dev/home.vue'),
        /* no children */
      },
      {
        path: 'lobby',
        name: 'Lobby preview',
        component: () => import('/app/frontend/src/pages/dev/lobby.vue'),
        /* no children */
      },
      {
        path: 'play',
        name: 'Play preview',
        component: () => import('/app/frontend/src/pages/dev/play.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/friends',
    name: 'Friends',
    component: () => import('/app/frontend/src/pages/friends.vue'),
    /* no children */
    meta: {
      "requiresAuth": true
    }
  },
  {
    path: '/leaderboard',
    name: 'Leaderboard',
    component: () => import('/app/frontend/src/pages/leaderboard.vue'),
    /* no children */
  },
  {
    path: '/live',
    /* internal name: '/live' */
    /* no component */
    children: [
      {
        path: ':id',
        name: '/live/[id]',
        component: () => import('/app/frontend/src/pages/live/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('/app/frontend/src/pages/login.vue'),
    /* no children */
    meta: {
      "requiresNoAuth": true
    }
  },
  {
    path: '/play',
    name: '/play',
    component: () => import('/app/frontend/src/pages/play.vue'),
    /* no children */
  },
  {
    path: '/privacy-policy',
    name: 'Privacy Policy',
    component: () => import('/app/frontend/src/pages/privacy-policy.vue'),
    /* no children */
  },
  {
    path: '/profile',
    /* internal name: '/profile' */
    /* no component */
    children: [
      {
        path: '',
        name: '/profile/',
        component: () => import('/app/frontend/src/pages/profile/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: '/profile/[id]',
        component: () => import('/app/frontend/src/pages/profile/[id].vue'),
        /* no children */
        meta: {
          "requiresAuth": true
        }
      }
    ],
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('/app/frontend/src/pages/register.vue'),
    /* no children */
    meta: {
      "requiresNoAuth": true
    }
  },
  {
    path: '/replay',
    /* internal name: '/replay' */
    /* no component */
    children: [
      {
        path: '',
        name: 'Replay',
        component: () => import('/app/frontend/src/pages/replay/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        name: '/replay/[id]',
        component: () => import('/app/frontend/src/pages/replay/[id].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/select-username',
    name: 'Select username',
    component: () => import('/app/frontend/src/pages/select-username.vue'),
    /* no children */
    meta: {
      "requiresNoAuth": true
    }
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('/app/frontend/src/pages/settings.vue'),
    children: [
      {
        path: '',
        name: 'Settings',
        component: () => import('/app/frontend/src/pages/settings/index.vue'),
        /* no children */
        meta: {
          "requiresAuth": true
        }
      },
      {
        path: 'cards',
        name: 'Cards',
        component: () => import('/app/frontend/src/pages/settings/cards.vue'),
        /* no children */
        meta: {
          "requiresAuth": true
        }
      },
      {
        path: 'legal',
        name: 'Legal',
        component: () => import('/app/frontend/src/pages/settings/legal.vue'),
        /* no children */
      },
      {
        path: 'password',
        name: 'Change password',
        component: () => import('/app/frontend/src/pages/settings/password.vue'),
        /* no children */
        meta: {
          "requiresAuth": true
        }
      },
      {
        path: 'profile',
        name: 'Edit Profile',
        component: () => import('/app/frontend/src/pages/settings/profile.vue'),
        /* no children */
        meta: {
          "requiresAuth": true
        }
      }
    ],
    meta: {
      "requiresAuth": true
    }
  },
  {
    path: '/test',
    name: '/test',
    component: () => import('/app/frontend/src/pages/test.vue'),
    /* no children */
  },
  {
    path: '/tos',
    name: 'Terms of Service',
    component: () => import('/app/frontend/src/pages/tos.vue'),
    /* no children */
  }
]
